import React, { Component } from "react";
import Grid from "@material-ui/core/Grid";
import { Config } from "../utils/Config";
import CircularProgress from "@material-ui/core/CircularProgress";
import { LOCALSTORAGE_KEY } from "../utils/constants.js";
import { setSearchQuery } from "../actions/main.js";
import { connect } from "react-redux";
import { getCookie, CookieName, setCookie } from "../utils/cookieManager";
import "../App.scss";
import ReactGA from "react-ga";

class Ticket extends Component {
  constructor(props) {
    super(props);
    this.state = {
      ticketData: "",
      isLoading: true
    };
  }

  componentDidMount() {
    const params = this.props.match.params;
    let bookingid = params.bookingId;
    const type = this.props.match.params.type;
    const email = params.email;
    const provider = params.provider;
    // const isAPSRTC = this.props.searchQuery.seatapidata.isAPSRTC;
    let busProvider = "";
    if (provider === "APSRTC") {
      busProvider = "&provider=APSRTC";
      bookingid = bookingid.split(",");
      bookingid = bookingid.join();
    }

    let urlTicketDetail = `${Config.SECURED_API_HOST}/api/platform/bus/ticket?bookingid=${bookingid}&email=${email}${busProvider}`;

    if (type === "pre-booking") {
      urlTicketDetail = `${Config.SECURED_API_HOST}/api/platform/bus/ticketprebooking?prebookingid=${bookingid}`;
    }

    this.fetchWithTimeOut(urlTicketDetail)
      .then(res => res.json())
      .then(res => {
        this.setState({
          ticketData: res,
          isLoading: false
        });
      })
      .catch(error => {
        console.log(error);
        //retry one more time
        fetch(urlTicketDetail)
          .then(res => res.json())
          .then(res => {
            if (res.Error === null) {
              this.setState({
                ticketData: res,
                isLoading: false
              });
            } else {
              //alert("Something went wrong");
              this.setState({
                isLoading: false
              });
            }
          });
      });
  }

  fetchWithTimeOut = (url, options, timeout = 6000) => {
    return Promise.race([
      fetch(url, options),
      new Promise((_, reject) =>
        setTimeout(() => reject(new Error("timeout")), timeout)
      )
    ]);
  };

  bookreturnTicket = () => {
    const s = JSON.parse(
      window.localStorage.getItem(LOCALSTORAGE_KEY.SOURCE_STATION)
    );
    const d = JSON.parse(
      window.localStorage.getItem(LOCALSTORAGE_KEY.DESTINATION_STATION)
    );

    let query = { type: "source", data: d.data };
    window.localStorage.setItem(
      LOCALSTORAGE_KEY.SOURCE_STATION,
      JSON.stringify(query)
    );
    // this.props.setSearchQuery(query);

    query = { type: "destination", data: s.data };
    //this.props.setSearchQuery(query);
    window.localStorage.setItem(
      LOCALSTORAGE_KEY.DESTINATION_STATION,
      JSON.stringify(query)
    );
    this.props.history.push("/bus-booking-phonepe");
  };

  cancelTicekt = () => {
    // ticket-details=ok&bookingid=379608346B45T9U3E&email=sumlata.karmadi@confirmtkt.com
    /*const data = this.state.ticketData;
        const email = this.props.match.params.email;
        const bookingId = (data.BookingId && data.BookingId !== '')? data.BookingId:this.props.match.params.bookingId;
        window.location = `https://www.confirmtkt.com/booking/cancellation.php?bookingid=${bookingId}&email=${email}&channel=phonepe-switch`;*/
    const token = getCookie(CookieName.USERTEMPTOKEN);
    const data = this.state.ticketData;
    const bookingId =
      data.BookingId && data.BookingId !== ""
        ? data.BookingId
        : this.props.match.params.bookingId;

    if (!token) {
      //----- phonepe sdk -------//
      this.setState({ isLoading: true });
      if (!window.PhonePe) {
        const script = document.createElement("script");
        script.src =
          "https://www.confirmtkt.com/phonepe-js-sdk-0.3.17/bundle.js";
        script.async = true;

        script.onload = () => {
          if (!getCookie(CookieName.USERTEMPTOKEN)) {
            this.generateTokenFromPhonePeGrant(bookingId);
          }
        };
        document.body.appendChild(script);
      } else {
        if (!getCookie(CookieName.USERTEMPTOKEN)) {
          this.generateTokenFromPhonePeGrant(bookingId);
        }
      }

      //----- phonepe sdk ends -------//
    } else {
      const cancelUrl = bookingId
        ? `/bus-booking-phonepe/cancel-ticket/${bookingId}`
        : "/bus-booking-phonepe/cancel-ticket";
      this.props.history.push(cancelUrl);
    }
  };

  generateTokenFromPhonePeGrant = bookingId => {
    const cancelUrl = bookingId
      ? `/bus-booking-phonepe/cancel-ticket/${bookingId}`
      : "/bus-booking-phonepe/cancel-ticket";
    let operatingSystem = window.PhonePe.Constants.OS.android;
    window.PhonePe.PhonePe.loggingEnabled = true;

    return window.PhonePe.PhonePe.build(
      window.PhonePe.Constants.Species.web,
      operatingSystem
    ).then(sdk => {
      sdk
        .fetchAuthToken()
        .then(res => {
          console.log("token granter");
          this.setState({ phonepeToken: res.grantToken });
          //call server side api and get confirmtkt token
          return res.grantToken;
        })
        .then(phonepeGrantToken => {
          const tokenUrl = `https://securedapi.confirmtkt.com//api/platform/authenticatephonepe?grantToken=${phonepeGrantToken}`;
          fetch(tokenUrl)
            .then(res => res.json())
            .then(res => {
              setCookie(CookieName.USERTOKEN, res.userKey, 60);
              setCookie(CookieName.USERTEMPTOKEN, res.TempToken, 60);
              setCookie(CookieName.USERNAME, res.Name, 60);
              setCookie(CookieName.USERMOBILE, res.PhoneNumber, 60);
              setCookie(CookieName.USERIMG, res.ProfileImage, 60);
              setCookie(CookieName.USEREMAIL, res.Email, 60);

              ReactGA.event({
                category: "login",
                action: "login-otp-verified-success"
              });

              this.props.history.push(cancelUrl);
            });
        })
        .catch(err => {
          console.log("Error occured while fetching the grant token");
          let landingPath = cancelUrl;
          this.props.history.push({
            pathname: "/bus-booking-phonepe/account-login",
            state: { defaultPath: landingPath }
          });
        });
    });
  };

  time_convert = num => {
    const hours = Math.floor(num / 60);
    const minutes = num % 60;
    return `${hours}:${minutes}`;
  };

  goHome = () => {
    console.log("hello");
    window.location = "https://www.confirmtkt.com/train-booking-phonepe/";
  };

  render() {
    const data = this.state.ticketData;
    let passenger = data.inventoryItems;
    let pickupTime = data.pickupTime;

    let seatName =
      (data && !data.Error && data.inventoryItems.length) > 0
        ? Object.keys(data.inventoryItems).map((key, i) => {
            return passenger[key].seatName + " ";
          })
        : "";

    let passengerName =
      (data && !data.Error && data.inventoryItems.length) > 0
        ? Object.keys(data.inventoryItems).map(key => {
            return passenger[key].passenger.name + " ";
          })
        : "";

    var date = new Date(parseInt(data.doj));

    if (this.props.match.params.provider === "APSRTC") {
      date = data.doj;
    } else {
      date = date.toDateString();
      pickupTime = this.time_convert(data.pickupTime);
    }
    const header = (
      <div className="header">
        <Grid container justify="flex-start" className="from-to">
          <Grid
            item
            xs={1}
            className="backBtn"
            onClick={() => {
              this.props.history.push("/bus-booking-phonepe");
            }}
          >
            <i className="material-icons">arrow_back</i>
          </Grid>
          <Grid item xs={10}>
            <div className="from">
              <span>Ticket Details</span>
            </div>
          </Grid>
        </Grid>
      </div>
    );

    const ticketDetails = (
      <div>
        <div
          style={{
            boxShadow: " 0px 2px 3px #b9b7b7",
            margin: "10px",
            background: "white"
          }}
        >
          <div style={{ padding: "10px" }}>
            <div className="route">
              <Grid container justify="flex-start">
                <Grid item xs={12} className="title">
                  <span>
                    {data.status},{" " + date}
                  </span>
                </Grid>
              </Grid>
              <hr />

              <Grid container justify="flex-start">
                <Grid item xs={6}>
                  <span className="label-text">FROM</span>
                  <br />
                  <span>{data.sourceCity}</span>
                </Grid>
                <Grid item xs={1}>
                  <i className="material-icons">arrow_right_alt</i>
                </Grid>
                <Grid item xs={5} style={{ textAlign: "right" }}>
                  <span className="label-text">TO</span>
                  <br />
                  <span>{data.destinationCity}</span>
                </Grid>
              </Grid>
              <hr />

              <Grid container justify="flex-start">
                <Grid item xs={6}>
                  <span className="label-text">BOARDS</span>
                  <br />
                  <span>{pickupTime}</span>
                </Grid>
                <Grid item xs={6} style={{ textAlign: "right" }}>
                  <span className="label-text">BOARDING POINT</span>
                  <br />
                  <span> {data.pickupLocation}</span>
                </Grid>
              </Grid>
            </div>

            <hr />

            <div>
              <Grid container justify="flex-start">
                <Grid item xs={12}>
                  <span className="label-text">TRAVEL</span>
                  <br />
                  <span>
                    {data.travels} {data.busType}{" "}
                  </span>
                </Grid>
              </Grid>
            </div>

            <hr />

            <div>
              <Grid container justify="flex-start">
                <Grid item xs={6}>
                  <span className="label-text">SEAT</span>
                  <br />
                  {seatName}
                  {/* {Object.keys(data.inventoryItems).map(key => {
                    key.seatName;
                  })} */}
                </Grid>
                <Grid item xs={6} style={{ textAlign: "right" }}>
                  <span className="label-text">
                    PASSENGERS <br />
                  </span>
                  {passengerName}
                </Grid>
              </Grid>
            </div>
            <hr />
            <div>
              <span className="label-text">BOARDING POINT DETAILS</span>
              <br />
              {data.pickupLocation},{data.sourceCity} ,{data.pickUpContactNo}
            </div>
          </div>
        </div>
        <div
          style={{
            boxShadow: " 0px 2px 3px #b9b7b7",
            margin: "10px",
            background: "white",
            padding: "10px"
          }}
        >
          <div>
            <Grid container justify="flex-start">
              <Grid item xs={6}>
                <span className="label-text">TICKET NUMBER</span>
                <br />
                {data.tin}
              </Grid>
              <Grid item xs={6} style={{ textAlign: "right" }}>
                <span className="label-text">
                  TOTAL <br />
                </span>
                {data.totalFare}
              </Grid>
            </Grid>
          </div>
          <hr />
          <div>
            <span className="label-text">PNR NUMBER</span> <br />
            {data.pnr}
          </div>
          <div>
            <span className="label-text">Booking ID</span> <br />
            {data.BookingId && data.BookingId !== ""
              ? data.BookingId
              : this.props.match.params.bookingId}
          </div>
        </div>
      </div>
    );

    const bottommenu = (
      <div
        className="bottom-fixed-details"
        style={{ fontSize: "14px", background: "aliceblue" }}
      >
        <div
          variant="contained"
          style={{ padding: "2rem", fontSize: "14px", textAlign: "center" }}
          className="ctkt-btn-success-bottom"
          onClick={this.goHome}
        >
          Home
        </div>
      </div>
    );

    const returnTicketButton = (
      <div style={{ marginTop: "10px", textAlign: "center" }}>
        <button
          type="button"
          className="btn btn-success"
          style={{ fontSize: "14px", marginLeft: "10px" }}
          onClick={this.bookreturnTicket}
        >
          Book Return Ticket
        </button>
      </div>
    );

    const bookticket = (
      <div style={{ marginTop: "10px", textAlign: "center" }}>
        <button
          type="button"
          className="btn btn-success"
          style={{ fontSize: "14px" }}
          onClick={e => this.props.history.push("/bus-booking-phonepe")}
        >
          Book Another Ticket
        </button>
      </div>
    );

    const cancelTicketButton = (
      <div style={{ marginTop: "10px", textAlign: "center" }}>
        <button
          type="button"
          className="btn btn-success"
          style={{ fontSize: "14px", marginBottom: "100px" }}
          onClick={this.cancelTicekt}
        >
          Cancel Ticket
        </button>
      </div>
    );

    const TicketBlock = this.state.isLoading ? (
      <div className="loading fixed">
        <CircularProgress />
      </div>
    ) : data && !data.Error && data.inventoryItems.length > 0 ? (
      ticketDetails
    ) : (
      ""
    );

    return data && !data.Error ? (
      <div
        className="train-list background-grey"
        style={{ padding: "0px", fontSize: "14px", marginBottom: "200px" }}
      >
        {header}
        <div
          className="container"
          style={{ textAlign: "center", display: "flex" }}
        >
          {bookticket}
          {/*returnTicketButton*/}
        </div>
        {bottommenu}
        {TicketBlock}
        {data.status && data.status.toUpperCase() === "CANCELLED"
          ? ""
          : cancelTicketButton}
      </div>
    ) : (
      <div
        className="train-list background-grey"
        style={{ padding: "0px", fontSize: "14px", marginBottom: "200px" }}
      >
        {header}
        <div className="loading fixed">
          {data.Error ? (
            <div>
              <div style={{ fontSize: "14px" }}>Error</div>
              <div style={{ fontSize: "18px" }}>{data.Error}</div>
            </div>
          ) : (
            ""
          )}
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    searchQuery: state.searchReducer
  };
};

const mapDispatchToProps = dispatch => {
  return {
    setSearchQuery: query => {
      dispatch(setSearchQuery(query));
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Ticket);
